import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/gestionTiempos/resultSettlementHours";
import resultSettlementHours from "../../models/gestionTiempos/information/resultSettlementHours";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    date: null,
    settlementHours: [],
    editItems: [],
  },
  mutations: {
    setDate(state, data) {
      state.date = data;
    },
    setSettlementHours(state, data) {
      state.settlementHours = data;
    },
    setEdit(state, options) {
      state.editItems = options;
    },
  },
  actions: {
    async getResults(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let items = await state.state.service.getResultsSettlement(
            state.state.date
          );
          state.commit("setSettlementHours", items);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.editItems).then(() => {
            let item = state.state.editItems;

            let options = state.state.settlementHours;

            options = options.map((option) => {
              if (
                option.authorizedAmount !=
                  state.state.editItems.authorizedAmount ||
                option.unauthorizedAmount !=
                  state.state.editItems.unauthorizedAmount
              ) {
                return option;
              }

              item = resultSettlementHours.fromJson({
                liqId: item.liqId,
                conceptoId: item.conceptId,
                csCostoId: item.csCostoId,
                cantLiq: item.settledAmount,
                cantAut: item.authorizedAmount,
                cantNoAut: item.unauthorizedAmount,
                nomLiqM: item.nameLiq,
                nomConcepto: item.nameConcept,
                nomCsCosto: item.nameCost,
              });
              return item;
            });

            state.commit("setSettlementHours", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
